import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';

import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/styles';

import withRoot from '../../styles/withRoot';

import BlueButton from '../../components/buttons/BlueButton';
import FlagButtom from '../../components/buttons/FlagButton';
import Snackbar from '../../components/labels/Snackbar';
import Link from '../../components/buttons/Link';
import Loading from '../../components/dialogs/loading';

import passwordIcon from '../../images/password_blue.svg';
import user from '../../images/user_blue.svg';

import { bindActionCreators } from 'redux';
import * as actionsSession from '../../actions/session.actions';

// eslint-disable-next-line
import style from './_style.css';

import logo from './logo.jpg';

const styles = (theme) => ({});

class Login extends React.Component {
    state = {
        error: undefined,
        launching: false,
        email: '',
        password: '',
    };

    constructor(props) {
        super(props);
        this.enterFunction = this.enterFunction().bind(this);
    }

    UNSAFE_componentWillMount() {
        window.addEventListener('keydown', this.enterFunction);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.enterFunction);
    }

    enterFunction = () => (event) => {
        if (event.keyCode === 13) {
            this.handleClick();
        }
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.session.user) {
            this.props.history.push(
                this.props &&
                    this.props.location &&
                    this.props.location.state &&
                    this.props.location.state.from
                    ? this.props.location.state.from
                    : '/processes',
            );
        }
        if (nextProps.error) {
            this.setState({ error: nextProps.error });
        }
    }

    handleClick = (event) => {
        const { email, password, launching } = this.state;
        if (email && password && !launching) {
            this.setState({ launching: true });
            this.props
                .loginUser(email, password)
                .then()
                .catch((error) => this.setState({ launching: false, error: error.message }));
        }
    };

    handleReset = (event) => {
        this.props.history.push('/password-reset');
    };

    handleClose = (event) => {
        this.setState({ error: undefined });
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    render() {
        const { error, launching, email, password } = this.state;
        const { intl } = this.props;
        const divStyleUser = { backgroundImage: 'url(' + user + ')' };
        const divStylePassword = { backgroundImage: 'url(' + passwordIcon + ')' };
        return (
            <form>
                <div className={'fullscreen flex_full_column'}>
                    <div className={'flex_auto_row padding_borders elements_from_right'}>
                        <FlagButtom url={'/user/login'} />
                    </div>
                    <div className="flex_full_column center">
                        <Grid container justify="center" className={'flex_auto_row align_center'}>
                            <Grid item xs={10} sm={4} className="padding_bottom_48">
                                <img alt="logo" className="logoLogin padding_bottom_48" src={logo} />
                                <div className={'flex_auto_row margin_top_48 align_center'}>
                                    <div
                                        style={divStyleUser}
                                        className={'padding_left_36 text_field_icon  '}
                                    />
                                    <TextField
                                        fullWidth
                                        autoFocus
                                        id="email"
                                        name="email"
                                        required
                                        helperText={
                                            !email ? intl.formatMessage({ id: 'required' }) : ''
                                        }
                                        label={intl.formatMessage({ id: 'email' })}
                                        value={email}
                                        onChange={this.handleChange}
                                        margin="normal"
                                    />
                                </div>
                                <div className={'flex_auto_row margin_top_24 align_center'}>
                                    <div
                                        style={divStylePassword}
                                        className={'padding_left_36 text_field_icon'}
                                    />
                                    <TextField
                                        fullWidth
                                        id="password"
                                        name="password"
                                        required
                                        helperText={
                                            !password
                                                ? intl.formatMessage({ id: 'required' })
                                                : ''
                                        }
                                        label={intl.formatMessage({ id: 'password' })}
                                        type="password"
                                        margin="normal"
                                        onChange={this.handleChange}
                                    />
                                    <Link id="recovery_password" onClick={this.handleReset} />
                                </div>
                                <div className="padding_bottom_48 padding_top_48">
                                    <BlueButton
                                        id="login"
                                        noValid={!email || !password}
                                        onClick={this.handleClick}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                    {error && (
                        <Snackbar
                            open={true}
                            variant="error"
                            text={error}
                            nonavbar={true}
                            onClose={this.handleClose}
                        />
                    )}
                    {launching && <Loading open opacity />}
                </div>
            </form>
        );
    }
}

Login.propTypes = {
    theme: PropTypes.object.isRequired,
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    return {
        form: state.form,
        session: state.session,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actionsSession), dispatch);
};

Login = injectIntl(Login);

Login = withRouter(Login);

Login = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Login);

export default withRoot(withStyles(styles, { withTheme: true })(Login));



// WEBPACK FOOTER //
// ./src/pages/knowhow/Login.js